import { SSC_SEM_API_URL } from "../../settings/config";
import {
  fetchBacklinksOverviewInProgress,
  fetchBacklinksOverviewSuccess,
  fetchBacklinksOverviewFailed,
  fetchResourceInProgress,
  fetchResourceSuccess,
  fetchResourceFailed
} from "./creators";
import { authRequest } from "../authorizedRequests";
import { getOffset, hasOverviewForInterval } from "./selectors";

const getApiUrlPath = (resourceType) => {
  let paths = {
    backlinks: "",
    referring_domains: "/referring-domains",
    top_anchors: "/top-anchors",
    tld_distribution: "/tld-distribution",
    top_countries: "/top-countries"
  };

  return paths[resourceType] || "";
};

const fetchOverview = (domain, startDate, endDate) => {
  return (dispatch, getState) => {
    const resourceType = "overview";
    const apiUrl = `${SSC_SEM_API_URL}/backlinks/overview?domain=${domain}&start_date=${startDate}&end_date=${endDate}`;

    if (hasOverviewForInterval(getState(), domain, startDate, endDate)) {
      return Promise.resolve();
    }

    dispatch(fetchBacklinksOverviewInProgress(resourceType, domain));
    return authRequest(apiUrl, dispatch, getState)
      .then((response) => {
        dispatch(fetchBacklinksOverviewSuccess(resourceType, domain, response));
      })
      .catch((_) => {
        dispatch(fetchBacklinksOverviewFailed(resourceType, domain));
      });
  };
};

const fetchResource = (resourceType, domain, orderBy, orderDir, offset = 0) => {
  return (dispatch, getState) => {
    const resourcePath = getApiUrlPath(resourceType);
    const apiUrl = `${SSC_SEM_API_URL}/backlinks${resourcePath}?domain=${domain}&order_by=${orderBy}&order_dir=${orderDir}&offset=${offset}`;

    if (getOffset(getState(), domain, resourceType, `${orderBy}_${orderDir}`) > offset) {
      return Promise.resolve();
    }

    dispatch(fetchResourceInProgress(resourceType, domain, orderBy, orderDir));

    authRequest(apiUrl, dispatch, getState)
      .then((response) => {
        dispatch(fetchResourceSuccess(resourceType, domain, orderBy, orderDir, response));
      })
      .catch((_) => {
        dispatch(fetchResourceFailed(resourceType, domain, orderBy, orderDir));
      });
  };
};

export { fetchResource, fetchOverview };
